export interface Column {
  key: string;
  title: string;
}

export type ExportModalPayload = Omit<ExportModalSchema, 'isOpened'>;

export enum ExportEntity {
  LEAD = 'lead',
  USER = 'user',
  INVOICE = 'invoice',
  CONTRACT = 'contract',
  BOX = 'box',
  CREDIT_NOTE = 'creditNote',
  INSURANCE = 'insurance',
  SELF_ISSUED_RECEIPT = 'selfIssuedReceipt',
  DEPOSIT = 'deposit',
  OCCUPANCY_BOX = 'occupancy-box',
  INCOME_STATISTICS = 'income-statistics',
  ARRIVAL_STATISTICS = 'arrival-statistics',
  SIZE_CODE = 'size-code',
  BOXES_REVENUE = 'boxes-revenue',
}

export interface ExportModalSchema {
  isOpened: boolean;
  filters: AnyObject;
  columns: Column[];
  entity: Nullable<ExportEntity>;
}

export interface ColumnOption {
  label: string;
  value: string;
}
